import { linkListStateType, ActionType, reducerStoreType } from "./types";

const defaultState = {
  linkListInfo: {
    total: 0,
    list: []
  },
  linkFilters: {
    currentPage: 1,
    recordsPerPage: 20,
    startDate: '',
    endDate: '',
    status: -1
  },
  linkDetail: {
    id: 0,
    currency: '',
    tradeAmt: 0,
    tradeSummary: '',
    status: 0,
    createTime: '',
    payTime: '',
    payLink: ''
  }
}

const searchLink = (state: linkListStateType = defaultState, action: ActionType<any>) => {
  switch (action.type) {
    case 'SET_LINK_LIST_INFO':
      return {
        ...state,
        linkListInfo: action.payload
      }
    case 'SET_LINK_DETAIL':
      return {
        ...state,
        linkDetail: action.payload.detail
      }
    case 'SET_LINK_DATE':
      return {
        ...state,
        linkFilters: {
          ...state.linkFilters,
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      }
    case 'SET_LINK_STATUS':
      return {
        ...state,
        linkFilters: {
          ...state.linkFilters,
          status: action.payload.settleStatus
        }
      }
    case 'RESET_LINK_PAGE':
      return {
        ...state,
        linkFilters: {
          ...state.linkFilters,
          currentPage: action.payload.currentPage,
          recordsPerPage: action.payload.recordsPerPage,
        }
      }
    case 'CLEAR_LINK_FILTERS':
      return {
        ...state,
        linkFilters: {
          ...defaultState.linkFilters,
        }
      }
    case 'SET_LINK_PAGE_INDEX':
      return {
        ...state,
        linkFilters: {
          ...state.linkFilters,
          currentPage: action.payload.currentPage
        }
      }
    case 'SET_LINK_PAGE_SIZE':
      return {
        ...state,
        linkFilters: {
          ...state.linkFilters,
          currentPage: action.payload.currentPage,
          recordsPerPage: action.payload.recordsPerPage,
        }
      }
    default:
      return state;
  }
}

export const linkList = (state: reducerStoreType) => (state.searchLink.linkListInfo.list)
export const total = (state: reducerStoreType) => (state.searchLink.linkListInfo.total)
export const linkFilters = (state: reducerStoreType) => (state.searchLink.linkFilters)
export const linkDetail = (state: reducerStoreType) => (state.searchLink.linkDetail)

export default searchLink